module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-collapse",
    class: {
      'list-panel': _vm.listPanel
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-371ae79a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/collapse/rtCollapse.vue
// module id = 2115
// module chunks = 137